export default __webpack_public_path__ + "static/media/cardboard_study_4.879ed95b.jpg";